module.exports = __webpack_public_path__ + "static/img/home_managementmodel_icon_manyToOne.65eada7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_managementmodel_icon_manyToOne.png
// module id = FRSy
// module chunks = 0